import React from "react";

const SpacePlaceholder = () => (
  <div className="space-tile ux-space-tile--loading" />
);

export default SpacePlaceholder;
